import React, { ReactNode } from 'react';
import { Flex, Text } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
}

const AdditionalInformationWrapper: React.FC<Props> = ({ children }) => {
  return (
    children && (
      <Flex flexDirection="column">
        <Flex backgroundColor="surfaceSecondaryFill" padding={4}>
          <Text textStyle="headingItem">Additional Information</Text>
        </Flex>
        <Flex
          backgroundColor="surfacePrimaryFill"
          width="100%"
          padding={4}
          flexDirection={'column'}
        >
          {children}
        </Flex>
      </Flex>
    )
  );
};
export default AdditionalInformationWrapper;
